<template>

  <div class="container-fluid container-temperature">
    <div class="tab-header" v-if="employees">
      <form action="" class="d-flex flex-column justify-content-center" @submit.prevent="getResult">
        <div class="col-12 d-flex align-items-center ">

         <div class="col-md-2 col-sm-4 form-group mb-3">
            <label for="filter-wr-name" class="form-label">მომხმარებელი</label>
            <v-select v-model="selectedEmployee" label="nickname" id="filter-wr-name"
                       :options="employees"
                      placeholder="აირჩიეთ მომხმარებელი"
                      :class="v$.selectedEmployee.$error ? 'red' : ''"
            >
              <template v-slot:no-options>სია ცარიელია</template>
            </v-select>

          </div>

          <div class="form-group mb-3 dropdown-height">
            <label for="period-name" class="form-label">პერიოდი</label>
            <DateRangePicker element-id="user-daterange" date-range-value="dateRangeValue" />
          </div>


          <div class="col-md-2 col-sm-4 form-group  button-groups d-flex">
            <button type="submit" class="btn btn-primary">
              გენერირება
            </button>
          </div>


        </div>

      </form>
    </div>

    <div class="col-12 tab-content">

      <transition name="fade" mode="out-in">

        <table class="table" v-if="!this.loading && resultData && resultData.list.data">
          <thead>
          <tr>
            <th @click.prevent="sortBy('tstamp')">
              თარიღი
              <template v-if="isFilteredBy('tstamp')">
                <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
              </template>
            </th>
            <th @click.prevent="sortBy('tablename')">
              ცხრილი
              <template v-if="isFilteredBy('tablename')">
                <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
              </template>
            </th>
            <th @click.prevent="sortBy('action')">
              ქმედება
              <template v-if="isFilteredBy('action')">
                <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
              </template>
            </th>
            <th>
              მონაცემები
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="result in resultData.list.data" v-bind:key="result">
            <td>{{ dateTime(result.tstamp) }}</td>
            <td>{{ result.tablename }}</td>
            <td>{{ actionNamify(result.action) }}</td>
            <td v-html="transformActionToReadableData(result)"></td>
          </tr>
          </tbody>
        </table>
      </transition>

      <transition name="fade" mode="out-in">
        <LoaderItem custom-classes="splash-screen-child" v-if="this.loading"></LoaderItem>
      </transition>
    </div>
    <template v-if="this.last_page > 1">
      <v-pagination
          v-model="this.page"
          :pages="this.last_page"
          :range-size="1"
          active-color="#DCEDFF"
          @update:modelValue="paginationHandler"
      />
    </template>

  </div>

</template>

<script>

import {ref} from "vue";
import DateRangePicker from "@/components/partials/reusable/DateRangePicker";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import LoaderItem from "@/components/partials/LoaderItem";
import ActionStringNormalize from "@/helpers/ActionStringNormalize";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import moment from "moment/moment";

export default {
  name:'UserActionReport',
  components:{DateRangePicker, LoaderItem, VPagination},
  computed:{
    resultData(){
      return this.$store.state.reports.userActions.data
    },
    employees(){
      if (this.$store.state.reports.employees.data){
        return this.$store.state.reports.employees.data.employees
      }
      return []
    }
  },
  methods:{
    isFilteredBy(key){
      if (this.filteringState.key === key){
        return true
      }
      return false
    },
	dateTime(value) {
      return moment(value).format('YYYY/MM/DD HH:mm:ss');
	},
    sortBy(key, nested = false){
      this.changeFilterState(key)

      let splitedKey = key.split('.')[key.split('.').length - 1]

      this.resultData.list.data.sort((a,b)=>{
        let comparableA = a[splitedKey]
        let comparableB = b[splitedKey]

        if (nested){
          let path = nested.split('.')
          let tmpObj  = null
          let tmpObjB = null
          for (let i = 0 ; i < path.length; i++){
            if (i === 0){
              tmpObj = a[path[0]]
              tmpObjB = b[path[0]]
              continue
            }
            tmpObj = tmpObj[path[i]]
            tmpObjB = tmpObjB[path[i]]

          }
          if (tmpObj && tmpObjB){
            comparableA = tmpObj[splitedKey]
            comparableB = tmpObjB[splitedKey]
          }
        }

        if (this.filteringState.ordering === 'DESC'){
          return  comparableA > comparableB ? 1 : -1
        }else{
          return  comparableA < comparableB ? 1 : -1
        }
      })
    },
    changeFilterState(key){
      if (this.filteringState.key === key){
        this.filteringState.ordering = this.filteringState.ordering ===  'ASC' ? 'DESC' : 'ASC'
        return
      }
      this.filteringState.key = key
      this.filteringState.ordering = 'DESC'
    },
    getIconByOrdering(){
      let icon = 'sort-down'
      if (this.filteringState.ordering === 'DESC'){
        icon = 'sort-up'
      }
      return icon
    },
    paginationHandler(page){
      this.currentPage = page
      this.getResult()
    },
    actionNamify(action){
      switch (action){
        case "INSERT":
          return "ჩაწერა";
        case "UPDATE":
          return "განახლება";
        case "DELETE":
          return "წაშლა";
        default:
          return action;
      }
    },
    transformActionToReadableData(report){
      let oldData = JSON.parse(report.rowdata)
      let currentData = JSON.parse(report.newdata)
      let presentData = ''
      if (report.action === "INSERT"){
        for (let entityKey  in currentData){
          presentData += ` ${ActionStringNormalize.normalized(entityKey)} : ${ActionStringNormalize.valueTryLinking(currentData,currentData[entityKey],report.tablename)} <br>`
        }
      }
      else if(report.action === "DELETE"){
        presentData = "მონაცემის წაშლა"
      }else{
        let changed = JSON.parse(report.changed);
        //else we need compare rowdata with newdata
        for (let entityKey  in changed){
          presentData += ` ${ActionStringNormalize.normalized(entityKey)} : ${ActionStringNormalize.valueTryLinking(oldData,oldData[entityKey],report.tablename)} <br>`
        }
      }
      return presentData
    },
    selectWeek(week){
      this.weeksArray[week] ? delete this.weeksArray[week] : this.weeksArray[week] = week
    },
    isSelectedWeek(weekIndex){
      return this.weeksArray[weekIndex] ? 'active-week' : '';
    },
    async getResult(){
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return 0
      }else{
        this.loading = true
        let filterData = {
          user_nickname: this.selectedEmployee,
          dateRange: document.getElementById('user-daterange').value.replace(/\./g,'/'),
          page: this.currentPage,
          perPage: this.perPage,
        }
        this.$store.dispatch('reports/getUserActionReports', filterData).then(
            ()  =>{
              this.loading = false
              this.last_page = this.resultData.list.last_page
              this.page = this.resultData.list.current_page
            }
        )
      }

    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return {
      selectedEmployee: ref(null),
      loading: true,
      currentPage: ref(1),
      perPage: ref(20),
      last_page: ref(0),
      page: ref(1),
      filteringState: ref({
        ordering: 'DESC',
        key: null
      })
    }
  },
  mounted() {
    this.$store.dispatch('reports/getEmployees').then(
        () => {
          this.loading = false
          this.selectedEmployee = this.employees[0]
        }
    )
  },
  validations () {
    return {
      selectedEmployee: { required },
    }
  }
}
</script>

<style scoped>


.week-col{
  width: 22.2%;
}

.container-temperature{
  padding-left: 0;
  padding-right: 0;
}

.tab-header{
  padding:15px
}

.form-group:not(:first-child){
  margin-left: 10px;
}




.input-group-text{
  border: 1px solid var(--dropzone-border);
  background: #ffffff;
}



.no-padding{
  padding: 5px;
}


.vs__dropdown-toggle{
  height: 100% !important;
  border: 1px solid var(--dropzone-border) !important;
  min-width: 100px;
}

.vs__search{
  display: block !important;
  padding: .11rem 0 !important;
}


.addon-select > .vs__dropdown-toggle{
  border: 1px solid var(--dropzone-border);
  border-left: 0 !important;
  border-radius: 0;
  border-right: 0;
}

 .second-addon-select > .vs__dropdown-toggle{
   border-left: 0 !important;
   border-right: 1px solid var(--dropzone-border);
   border-top-right-radius: 5px !important;
   border-bottom-right-radius: 5px !important;
 }

 .form-control{
   border: 1px solid var(--dropzone-border);
 }

 .red{
   border-radius: 5px;
   border: 1px solid red !important;
 }

.splash-screen-child{
  position: relative !important;
  padding-top: 5% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
}

.input-group-text.active-week{
  background: var(--submit-button-bg) !important;
  color: #ffffff !important;
}

.table{
  color:var(--second-titles);
  font-family: "TBCDinNusxuri-Medium";
  font-size: 16px;
}
.table > :not(:first-child){
  border: 1px solid var(--border-color) !important;
}
.table tbody tr:last-child{
  border: transparent;
}
.table tbody tr:hover{
  background: var(--hover-item);
  cursor: pointer;
}

.table > thead{
  vertical-align: middle;
  color: var(--text-sub-bold-color);
}

.table > :not(:first-child){
  border-top: 1px solid var(--border-color);
}

.table td:first-child, table th:first-child{
  padding-left: 20px;
}

.no-padding-div{
  padding-left: 5px;
  padding-right: 5px;
}

.tab-content{
  height: 66vh;
}


</style>